import { type PropsWithChildren } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { FadeView, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsTab = (props: Props) => {
  const { children, nativeID, tabLinkID } = props;

  const { match } = useResponsive();

  const responsiveContainerStyles = match([styles.containerXS, styles.containerSM]); // prettier-ignore

  return (
    <FadeView
      show={true}
      duration={theme.transitions.long}
      style={responsiveContainerStyles}
      nativeID={nativeID}
      accessibilityLabelledBy={tabLinkID}
      {...EXTRA_PROPS}
    >
      {children}
    </FadeView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const EXTRA_PROPS = Platform.select({
  web: { accessibilityRole: 'tabpanel' as never },
  default: {},
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    paddingTop: theme.spacing['5'],
  },
  containerSM: {
    paddingTop: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  tabLinkID: string;
  nativeID: string;
}>;
